import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { deleteZone } from "./zone";

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertLocationEntry = createAsyncThunk('insertLocationEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertLocation_Schl`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const updateSchoolEntry = createAsyncThunk('updateSchoolEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=updateSchoolEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertLocationEntry2 = createAsyncThunk('insertLocationEntry2', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertLocationEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateItemEntry = createAsyncThunk('updateItemEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateItem`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateLocation = createAsyncThunk('updateLocation', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateLocation`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchLocationData = createAsyncThunk('fetchLocationData', async (id) => {
    try {

        let endpoint = 'getLocationSchldata';
        if (id) {
            endpoint = `getLocationSchldata&locId=${id}`;
        }
        // if (userId) {
        //     endpoint = `getLocationSchldata&userId=${userId}`;
        // }
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchLocationData2 = createAsyncThunk('fetchLocationData2', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getLocationdata`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleLocation = createAsyncThunk('fetchSingleLocation', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getLocationdata&locId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteLocation = createAsyncThunk('deleteLocation', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteLocation&locId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSchldata = createAsyncThunk('deleteSchldata', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteSchoolEntry&schlId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const locationSlice = createSlice({
    name: 'LocationData',
    initialState: {
        isLoading: false,
        locdata: null,
        locdata2: null,
        singleloc: null,
        deleloc: null,
        delSchl: null,
        delZone: null,
        isError: false
    },

    extraReducers: (builder) => {

        builder.addCase(fetchLocationData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchLocationData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.locdata = action.payload;
        });
        builder.addCase(fetchLocationData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchLocationData2.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchLocationData2.fulfilled, (state, action) => {
            state.isLoading = false;
            state.locdata2 = action.payload;
        });
        builder.addCase(fetchLocationData2.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchSingleLocation.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleLocation.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleloc = action.payload;
        });
        builder.addCase(fetchSingleLocation.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteLocation.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteLocation.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleloc = action.payload;
        });
        builder.addCase(deleteLocation.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteZone.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteZone.fulfilled, (state, action) => {
            state.isLoading = false;
            state.delZone = action.payload;
        });
        builder.addCase(deleteZone.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default locationSlice.reducer;
